import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=90cc89b8&scoped=true&"
import script from "./SettingsMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMenu.vue?vue&type=style&index=0&id=90cc89b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cc89b8",
  null
  
)

export default component.exports